import React, { useState } from "react";
import { Link } from "react-router-dom";
import Pagination from "./Pagination"; // Import the Pagination component
import IMG from "./../../assets/16.09.2022-2-1-2.jpg";
import posts from "./PostList"; // Your list of posts
import "./home.css";
import SchoolPart from "./SchoolPart";

const POSTS_PER_PAGE = 12;

export const Home = () => {
  // State to keep track of the current page
  const [currentPage, setCurrentPage] = useState(1);
  // State for search functionality
  const [searchTerm, setSearchTerm] = useState("");

  // Remove duplicates and sort posts by ID in descending order
  const uniquePosts = Array.from(new Set(posts.map((post) => post.id))).map(
    (id) => posts.find((post) => post.id === id)
  );
  const sortedPosts = uniquePosts.slice().sort((a, b) => b.id - a.id);

  // Filter posts based on search term
  const filteredPosts = sortedPosts.filter((post) => {
    const searchLower = searchTerm.toLowerCase();
    const titleMatch = post.title && post.title.toLowerCase().includes(searchLower);
    const descriptionMatch = post.briefText && post.briefText.toLowerCase().includes(searchLower);
    return titleMatch || descriptionMatch;
  });

  // Calculate the indexes for the current page's posts
  const startIndex = (currentPage - 1) * POSTS_PER_PAGE;
  const endIndex = startIndex + POSTS_PER_PAGE;
  const paginatedPosts = filteredPosts.slice(startIndex, endIndex);

  // Function to handle changing the page
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Function to handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  return (
    <div>
      <header className="header">
        <img src={IMG} alt="Header" className="header-image" />
      </header>

      <SchoolPart />

      {/* Search Section */}
      <div className="search-section">
        <div className="search-container">
          <input
            type="text"
            placeholder="ძებნა პოსტების სახელით ან აღწერით..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="search-input"
          />
          {searchTerm && (
            <div className="search-results-info">
              <span className="search-count">
                ნაპოვნია {filteredPosts.length} პოსტი
              </span>
              <button 
                onClick={() => setSearchTerm("")} 
                className="clear-search-btn"
                title="ძებნის გასუფთავება"
              >
                ✕
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="post-container">
        {paginatedPosts.length > 0 ? (
          paginatedPosts.map((post) => (
            <div key={post.id} className="post">
              <img src={post.image} alt={post.title} className="post-image" />
              <h2 className="post-title">{post.title}</h2>
              <p className="post-brief-text">{post.briefText}</p>
              <Link to={`/post/${post.id}`} className="post-read-more">
                მეტის ნახვა
              </Link>
            </div>
          ))
        ) : searchTerm ? (
          <div className="no-results">
            <p>ძებნის შედეგი ვერ მოიძებნა "{searchTerm}"</p>
            <p>სცადეთ სხვა საკვანძო სიტყვები</p>
          </div>
        ) : null}
      </div>

      {filteredPosts.length > 0 && (
        <Pagination
          totalPosts={filteredPosts.length}
          postsPerPage={POSTS_PER_PAGE}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};
